module.exports = __webpack_public_path__ + "img/mac.5df73511.png";